/* Dansk katalog for locale-payroll-delivery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'err.payslip.notAuthorized': 'Du har ikke adgang til denne anmodning om udsendelse.',
  'err.payslip.approvedRunRequired': 'Godkend lønkørslen, før lønsedlerne sættes i kø.',
  'err.payslip.queueTooLarge': 'Lønseddeldataene er for store til at blive sat i kø. Kontakt support.',
  'pay.payslipSent': 'Lønseddel sendt.',
  'pay.payslipsSent': 'Lønsedler sendt.',
  'pay.payslipsSentAndPosted': 'Lønsedler sendt og løn bogført.',
  'pay.payslipsQueuedAndPosted': 'Løn bogført. Lønsedler sat i udsendelseskø.',
  'pay.payslipQueued': 'I kø til udsendelse',
  'pay.payslipsQueued': 'Lønsedler i udsendelseskø.',
  'pay.payslipGenerated': 'Genereret',
  'pay.payslipNotReady': 'Ikke klar',
  'pay.payslipScheduled': 'Planlagt',
});
